// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1c540eda","453":"db09bfe9","551":"34766d2a"}[chunkId] + ".chunk.js";
};